import _concat from "lodash/concat";
import promotions from "./promotions";

export default {
  path: "/promotions",
  component: () => import("@/layouts/FullLayout"),
  children: _concat(promotions)
};
